import { render, staticRenderFns } from "./FileLoader.vue?vue&type=template&id=01e86e88&"
import script from "./FileLoader.vue?vue&type=script&lang=js&"
export * from "./FileLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports